<template>
    <div class="projects">
        <h1 class="mt-5 p-5 font-weight-bold">
            About Projects
        </h1>
    
        <p class="mt-5 pl-5 pr-5 introduction">
            Projects are the best way to practice the knowledge reached. 
            here you will find few demos of projects that i have done. You could use the follow links, 
            to see more about each projetc.
           </p>
        
        
        <div class="p-5">
             <h4 class="font-weight-bold">
                Covid web aplication
            </h4>
            <p class="introduction">It is a web aplication where i had used Vue.js, axios, and bootstrap, 
                to create an app where you can see the last report of pandemic stats. 
                it has a minimalist desing and easy to use. 
                you just have to type the name of country and you will get update information about current cases in every country arround the globe. </p>
                <a href="https://covid19report.devmonc.com/#/">Try me</a>
        </div>
        <div class="p-5">
             <h4 class="font-weight-bold">
                Task app
            </h4>
            <p class="introduction">This is a small web aplication where users can insert a list of tasks. 
                The app are written on Vue.js and this app is using local store to save the data. </p>
                <a href="https://mariomoncada.github.io/TaskApp-with-Vue/">Try me</a>
        </div>
          <div class="p-5">
             <h4 class="font-weight-bold">
                 E-commers Shop 
            </h4>
            <p class="introduction">This aplication was wrotte  using HTML, CSS, and Pure JAVASCRIPT. At this project you can see all funcionalities such as Responsive desing,
                dimanmic elements and coursel.
            </p>
                <a href="https://mariomoncada.github.io/shop-demo/">Try me</a>
        </div>
        <div class="p-5">
             <h4 class="font-weight-bold">
                 Percents calculator 
            </h4>
            <p class="introduction">Basic calculator of percents. It was wrotte  using HTML, CSS, and Pure JAVASCRIPT. 
            </p>
                <a href="https://mariomoncada.github.io/shop-demo/">Try me</a>
        </div>
     <div class="p-5">
             <h4 class="font-weight-bold">
                 Towers realty web aplication 
            </h4>
            <p class="introduction">This project is the most important software development that i have done. this project was wrotte using Laravel and Vue.Js. My role was to create the front interface of this aplications. 
                get api reponses using axios dependency to consume APIs and Bootstrap.
            </p>
              
        </div>
          <div class="p-5">
              <a href="https://mariomoncada.github.io/first-porfolio/main.html"><h4>First porfolio</h4></a>
       <p class="introduction"> It was my first porfolio</p>
    </div>
        
    <div class="p-5">
       <p class="introduction"> If you want to know more about projects and resources code, you can find me on <a href="https://github.com/MarioMoncada">Github.com</a></p>
    </div>
    </div>
</template>
<script>
export default {
    name:"Projects"
}
</script>
<style lang="scss" scoped>
.introduction{
  font-size: 20px;;
}
</style>